export default __webpack_public_path__ + "static/media/StoreModuleIcon.e28b80f2.svg";